import { SxProps, Theme } from '@mui/material';

export const candidateProfileSearchInputSx = {
  form: {
    width: '100%',
    position: 'relative'
  },
  wrapper: (theme: Theme): SxProps => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: 'white',
    border: '1px solid transparent',
    borderImage: `${theme.palette.aiGradient} 1`,
    borderRadius: '4px',
    minHeight: '120px',
    maxHeight: '220px',
    boxSizing: 'border-box',
    overflow: 'hidden'
  }),
  selectedChipsContainer: {
    flexShrink: 0,
    flexWrap: 'wrap',
    padding: '14px 60px 0 14px',
    maxHeight: '96px',
    overflowY: 'auto'
  },
  searchInput: (placeholderOpacity = 1): SxProps => ({
    width: '100%',
    flex: 1,
    minHeight: '60px',
    border: 'none',
    outline: 'none',
    resize: 'none',
    fontFamily: 'inherit',
    fontSize: '16px',
    lineHeight: '20px',
    backgroundColor: 'transparent',
    color: 'inherit',
    padding: '14px',
    paddingRight: '48px',
    paddingBottom: '40px',
    boxSizing: 'border-box',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::placeholder': {
      color: '#939395',
      opacity: placeholderOpacity,
      transition: 'opacity 300ms ease-in-out'
    }
  }),
  sendButtonContainer: {
    position: 'absolute',
    bottom: '8px',
    right: '8px',
    zIndex: 1
  },
  sendButton: {
    padding: '2px'
  }
};
